import IcError from "./error.png";
import IcH5P from "./h5p.png";
import IcIndo from "./indo.png";
import IcMail from "./mail.gif";
import IcNotif from "./notif.gif";
import IcUK from "./uk.png";
import IcGoogle from "./google.png";
export { IcIndo, IcUK, IcNotif, IcMail, IcError, IcH5P, IcGoogle };
